<template>
  <div class="hidden-print">
    <Slideout :selectors="['.toggle-button']" menu="#menu" panel="#panel" />
    <nav id="navbar" class="navbar navbar-default navbar-fixed-top top">
      <div class="container-fluid">
        <div class="navbar-header">
          <button
            id="botaoMenu"
            data-test-id="button-menu-lateral"
            type="button"
            class="btn btn-primary navbar-brand toggle-button"
          >
            <span class="logo"> ca </span>
          </button>
        </div>
        <div id="menuUsuario" class="nav navbar-nav navbar-right">
          <SyncLoader
            :loading="carregando"
            :color="'#fff'"
            :size="'5px'"
            class="navbar-text"
          />
          <li class="toolbar-slot" style="margin-top: 5px; margin-right: 20px">
            <p class="navbar-btn">
              <slot name="toolbar" />
            </p>
          </li>
          <MenuUsuario />
        </div>
      </div>
    </nav>
    <div id="menu">
      <MenuLateral :items="menuItems" />
    </div>
  </div>
</template>

<script>
import ControleAcessoServico from '@/servicos/ControleAcessoServico'
import appStore from '@/stores'

import Slideout from '../Slideout'
import MenuLateral from './MenuLateral'
import MenuUsuario from './MenuUsuario'

const controleAcessoServico = new ControleAcessoServico()

export default {
  name: 'MenuTopo',
  components: { Slideout, MenuLateral, MenuUsuario },
  computed: {
    titulo() {
      return appStore.titulo
    },
    menuItems() {
      return controleAcessoServico.gerarMenu()
    },
    carregando() {
      return appStore.carregando
    },
  },
}
</script>

<style>
#botaoMenu {
  width: 40px;
  height: 40px;
  padding: 0 6px 0 0;
  margin: 5px 15px 5px 0;
  background-color: #004c4c;
  border: 5px solid #005d5d;
  border-radius: 40px;
  transition: all 0.5s ease-in;
}

#botaoMenu:hover {
  background-color: #001919;
  border: 5px solid #002a2a;
  border-radius: 40px;
}

.logo {
  position: relative;
  display: inline;
  font-family: 'Crushed', Arial, Helvetica, sans-serif !important;
  font-size: 2.1em;
  font-weight: 500;
  color: rgb(178, 216, 216);
  letter-spacing: -4px;
}

@media (max-width: 767px) {
  #navbar .container-fluid {
    position: relative;
    min-height: 50px;
  }

  #menuUsuario {
    position: absolute;
    top: 5px;
    right: 10px;
    display: flex;
    overflow: visible;
    align-items: center;
    float: none !important;
    margin: 0;
  }

  #menuUsuario .navbar-text,
  #menuUsuario li {
    float: none !important;
    margin: 0;
  }

  #menuUsuario .toolbar-slot {
    display: none;
  }
}
</style>
